import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApiPatch } from '../../../../api/hooks';
import { InfoIcon } from '../../model/icons';

const URL_PATTERN = /^https?:\/\/.+/;

// Карточка настройки базового URL фронтенда лагеря (из него строятся ссылки в QR-кодах точек).
export default function FrontendUrlCard({ campId, initialUrl, onSaved }) {
    const [value, setValue] = useState(initialUrl || '');
    useEffect(() => { setValue(initialUrl || ''); }, [initialUrl]);

    const patch = useApiPatch({ successMessage: 'URL фронтенда сохранён', withPreloader: true });

    const trimmed = value.trim();
    const valid = URL_PATTERN.test(trimmed);
    const dirty = trimmed !== (initialUrl || '').trim();
    const showError = trimmed.length > 0 && !valid;
    const canSave = valid && dirty && !patch.isPending;

    const save = () => {
        if (!canSave) return;
        patch.mutate(
            { url: `/api/camps/admin/camps/${campId}/frontend-url`, data: { frontendUrl: trimmed } },
            { onSuccess: (data) => onSaved(data) }
        );
    };

    return (
        <section className="camp-card camp-info">
            <div className="camp-infohead"><h3>URL фронтенда</h3></div>
            <p className="camp-flead">
                Базовый домен лагеря — из него формируются ссылки в QR-кодах точек. Если поле пустое, QR-коды не генерируются.
            </p>
            <div className="copy-row">
                <input
                    className="input"
                    type="url"
                    placeholder="https://solbaumanec.ru"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') save(); }}
                />
                <button type="button" className="btn btn-primary" onClick={save} disabled={!canSave}>
                    {patch.isPending ? 'Сохранение…' : 'Сохранить'}
                </button>
            </div>
            {showError && (
                <div className="camp-ferr">Укажите корректный URL, начинающийся с http:// или https://</div>
            )}
            <div className="camp-note">
                <InfoIcon />
                Например: https://solbaumanec.ru — без хвостового «/» (бэкенд срежет сам).
            </div>
        </section>
    );
}

FrontendUrlCard.propTypes = {
    campId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    initialUrl: PropTypes.string,
    onSaved: PropTypes.func.isRequired
};

FrontendUrlCard.defaultProps = { initialUrl: '' };
